import gql from 'graphql-tag'

export default gql`mutation ($user_role_id: Int!, $active_from: String!){
  checkTimesheetsAfterUserRoleRateChange(user_role_id: $user_role_id, active_from: $active_from)
}`